import React, { Fragment } from 'react';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import makeStyles from '@mui/styles/makeStyles';
import Copyright from '../../components/Copyrights/copyrights';
// import Background from '../../assets/Images/background.jpg';
import BackgroundUcl from '../../assets/Images/bg_ucl2.gif';
import NucleusLogo from '../../assets/Images/nUCLeus_logo.jpg';

// import Logo from '../../assets/Images/logo.png';
// import NavBar from '../../components/NavBar/NavBar';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import { Link } from 'react-router-dom';
import { numberExp } from '../../utils/regularExpression';
import ControlledDialog from '../../components/ControlledDialog/ControlledDialog';

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100vh',
  },
  image: {
    backgroundImage: `url(${BackgroundUcl})`,
    backgroundRepeat: 'no-repeat',
    backgroundColor:
      theme.palette.mode === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
    backgroundSize: 'cover',
    height: '100%'
  },
  image_logo: {
    backgroundImage: `url(${NucleusLogo})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    height: '100px',
    width: '230px'
  },
  paper: {
    margin: theme.spacing(2, 2),
    display: 'flex',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '90%', // Fix IE 11 issue.
    marginTop: theme.spacing(0),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    height: '80%'
  }
}));

const Login = () => {
  const classes = useStyles();
  const [show, setShow] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const [error, setError] = React.useState("");
  const [studentId, setStudentId] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [deactiveDialog, setDeactiveDialog] = React.useState({
    open: false,
    title: "",
    content: ""
  });

  const onFormSubmit = async e => {
    setError('');
    e.preventDefault();
    const data = new FormData(e.target);
    setIsLoading(true);
    const url = `${process.env.REACT_APP_API_DOMAIN}/${process.env.REACT_APP_SUB_API_NAME}/authentication/C03Authenticate?&isMobile=0` + '&platform=web' + '&version=0';
    await fetch(url, { method: "POST", body: data })
      .then(res => {
        if (!res.ok) {
          throw res;
        }
        return res.json();
      })
      .then(
        json => {
          if (json.success === 1) {
            if (json.isActive === 1) {

              window.localStorage.setItem("lmsData", JSON.stringify(json));
              window.localStorage.setItem("lmsToken", json.jwttoken);
              window.localStorage.setItem("lmsStudentId", studentId);
              sessionStorage.setItem("lmsFeeAnnouncementReadFlag", 0);
              sessionStorage.setItem("lmsFeedbackAnnouncementReadFlag", 0);
              sessionStorage.setItem("lmsAnnouncementReadFlag", 0);
              window.localStorage.setItem("studentShowGradeBookStatus", json.studentShowGradeBookStatus);

              window.location.replace("#/dashboard");
            } else {
              setDeactiveDialog({
                open: true,
                title: "Account Deactivated",
                content: json.deactiveMessage
              })
            }
          } else {
            setError('Invalid Email or Password');
          }
        },
        error => {
          setError('Invalid Email or Password');
          console.log(error);
        });

    setIsLoading(false);
  }

  const handleClickShowPassword = () => {
    const update = !show;
    setShow(update);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleChange = (e) => {
    let regex = "";
    const { name, value } = e.target;
    switch (name) {
      case "studentId":
        regex = new RegExp(numberExp);
        if (value && !regex.test(value)) {
          return;
        } else {
          setStudentId(value);
          setError('');
        }
        break;
      case "password":
        setPassword(value);
        setError('');
        break;
      default:
        break;
    }
  }


  return (
    <Fragment>
      <ControlledDialog open={deactiveDialog.open} title={deactiveDialog.title} content={deactiveDialog.content} handleClose={() => setDeactiveDialog({ open: false, title: "", content: "" })} />
      <Grid container component="main" className={classes.root}>
        {/* <NavBar logo={Logo} title="University College London" /> */}
        <Grid item xs={12} className={classes.image} >
          <Grid container justifyContent="space-around" alignItems="center" className={classes.root}>
            <Grid item xs={12} sm={7} md={5} lg={6}>
              <Box sx={{ display: { xs: 'none', md: 'block' } }}>
                <Typography variant="h2" style={{ color: 'white', textShadow: '1px 1px 2px black' }}>
                  WELCOME TO NUCLEUS <br /> THE UNIVERSAL COLLEGE LAHORE PORTAL
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={10} sm={6} md={5} lg={4}>
              <div style={{ alignContent: 'center', borderRadius: '18px', background: 'white' }}>
                <div component={Paper} elevation={6} className={classes.container}>
                  <div className={classes.paper}>
                    <div style={{ height: 16 }} />
                    <Grid item className={classes.image_logo} />
                    <div style={{ padding: 8 }}>
                      <Typography variant="h5" style={{ textAlign: 'left' }} gutterBottom>SIGN IN</Typography>
                    </div>
                    <form autoComplete="off" onSubmit={e => onFormSubmit(e)} className={classes.form}>
                      <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        id="studentId"
                        label="Nucleus Id"
                        name="studentId"
                        type="text"
                        value={studentId}
                        onChange={(e) => handleChange(e)}
                        autoFocus
                      />
                      <TextField
                        variant="outlined"
                        margin="normal"
                        required
                        fullWidth
                        name="password"
                        label="Password"
                        value={password}
                        onChange={(e) => handleChange(e)}
                        type={show ? "text" : "password"}
                        id="password"
                        InputProps={{
                          endAdornment:
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                size="large">
                                {show ? <Visibility /> : <VisibilityOff />}
                              </IconButton>
                            </InputAdornment>

                        }}
                      />
                      <span style={{
                        display: 'flex',
                        justifyContent: 'center',
                        marginBottom: '-12px',
                        color: '#e04848'
                      }}>{error}</span>
                      <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        style={{ backgroundColor: `${isLoading ? "#6272ce" : ""}` }}
                        color="primary"
                        className={classes.submit}
                        disabled={isLoading}
                      >
                        {isLoading ? <CircularProgress style={{ color: 'white' }} size={24} /> : "Login"}
                      </Button>
                      <Grid container justifyContent="space-between" spacing={2}>
                        <Grid item >
                          <Link to="/forgot-password" variant="body2">Forgot password?</Link>
                        </Grid>
                        <Grid item>
                          <Link to="/registration" variant="body2">{"Don't have an account?"}</Link>
                        </Grid>
                      </Grid>
                    </form>
                  </div>
                  <div style={{ paddingBottom: 25 }}>
                    <Copyright />
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Fragment>
  );
}

export default Login;